/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type ComponentPropsWithoutRef } from 'react';
import { useEntryPointSubscription } from '@jira/platform__entry-points-point-subscription/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import type { AnyEntryPoint } from '@jira/platform__entry-point/src/common/types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import type { EntryPointReferenceSubject } from '@jira/platform__entry-point/src/controllers/utils/use-entry-point-load-manager/index.tsx';
import {
	InternalEntryPointContainer,
	type InternalEntryPointContainerProps,
	// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
} from '@jira/platform__entry-points-internal-container/src/index.tsx';

export interface Props<TEntryPoint extends AnyEntryPoint> extends Omit<
	ComponentPropsWithoutRef<typeof InternalEntryPointContainer<TEntryPoint>>,
	'entryPointReference'
> {
	entryPointReferenceSubject: EntryPointReferenceSubject<TEntryPoint>;
}

export const JiraEntryPointContainer = <TEntryPoint extends AnyEntryPoint>({
	entryPointReferenceSubject,
	...containerProps
}: Props<TEntryPoint>): React.JSX.Element | null => {
	const entryPointReference = useEntryPointSubscription<TEntryPoint>(entryPointReferenceSubject);

	return entryPointReference ? (
		<InternalEntryPointContainer
			{...containerProps}
			entryPointReference={entryPointReference}
			placeholderName="jira-entry-point-container"
		/>
	) : null;
};

export const NestedEntryPointContainer: <TEntryPoint extends AnyEntryPoint>({
	entryPointReference,
	errorAttributes,
	errorFallback,
	fallback,
	id,
	packageName,
	placeholderName,
	runtimeProps,
	teamName,
}: InternalEntryPointContainerProps<TEntryPoint>) => React.JSX.Element =
	InternalEntryPointContainer;
